export default function recentlyViewedProducts() {
    if (typeof product !== 'undefined') {
        addToRecentlyViewed(product)
    }

    let recentlyViewedSection = document.querySelector(
        '.section-recentlyviewed'
    )
    if (recentlyViewedSection) {
        displayRecentlyViewed()
    }

    function addToRecentlyViewed(product) {
        let recentlyViewed =
            JSON.parse(localStorage.getItem('recentlyViewed')) || []

        // Remove product if it already exists in the list
        recentlyViewed = recentlyViewed.filter(
            (rvProduct) => rvProduct.id !== product.id
        )

        // Add the new product to the beginning of the list
        recentlyViewed.unshift(product)

        // Keep only the last 5 viewed products
        if (recentlyViewed.length > 3) {
            recentlyViewed.pop()
        }

        localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed))
    }

    function displayRecentlyViewed() {
        let recentlyViewed =
            JSON.parse(localStorage.getItem('recentlyViewed')) || []

        if (recentlyViewed.length > 0) {
            const container = document.getElementById(
                'recently-viewed-container'
            )

            let html = ''

            let productTileTMPL = document.querySelector(
                '#product-tile-template'
            )
            let productTileHTML = ''
            if (!productTileTMPL) {
                return
            }

            productTileHTML = productTileTMPL.innerHTML

            recentlyViewed.forEach((rvProduct, index) => {
                let thisProductHTML = productTileHTML

                if (product.badge) {
                    thisProductHTML = thisProductHTML.replaceAll(
                        '#BADGE#',
                        '<div class="product-badge">' +
                            rvProduct.badge +
                            '</div>'
                    )
                } else {
                    thisProductHTML = thisProductHTML.replaceAll('#BADGE#', '')
                }

                thisProductHTML = thisProductHTML.replaceAll(
                    '#URL#',
                    '/products/' + rvProduct.handle
                )
                thisProductHTML = thisProductHTML.replaceAll(
                    '#IMAGE#',
                    '<img src="' + rvProduct.featured_image + '"/>'
                )
                thisProductHTML = thisProductHTML.replaceAll(
                    '#TITLE#',
                    rvProduct.title
                )
                thisProductHTML = thisProductHTML.replaceAll(
                    '#HANDLE#',
                    rvProduct.handle
                )

                if (product.price_min !== rvProduct.price_max) {
                    thisProductHTML = thisProductHTML.replaceAll(
                        '#PRICE#',
                        window.formatMoney(rvProduct.price_min) +
                            ' - ' +
                            window.formatMoney(rvProduct.price_max)
                    )
                } else {
                    if (product.variants[0].compare_at_price) {
                        thisProductHTML = thisProductHTML.replaceAll(
                            '#PRICE#',
                            window.formatMoney(rvProduct.price) +
                                '<s>' +
                                rvProduct.variants[0].compare_at_price +
                                '</s>'
                        )
                    } else {
                        thisProductHTML = thisProductHTML.replaceAll(
                            '#PRICE#',
                            window.formatMoney(rvProduct.price)
                        )
                    }
                }

                html += thisProductHTML
            })

            container.innerHTML = html
        }
    }
}
